<template>
  <div>
    <nuxt-link
      :to="`/photo/${photo.photoId}/${photo.photoSlug}?from=leaderboard`"
    >
      <div
        v-if="((me && me.isNudeFilterActive) || !me) && photo.isNude"
        class="obscure-best-photo mb-4"
      >
        <p class="text-body-2 ma-0">NSFW Content</p>
      </div>
      <v-img
        v-else
        :src="$asa.getImageUrl(photo, 'thumb')"
        :alt="`${photo.fullName} photography.`"
        class="mb-4"
      />
    </nuxt-link>
    <div class="d-flex">
      <nuxt-link
        :to="`/photographer/${photo.userUserName || photo.userId}`"
        class="flex-avatar"
      >
        <v-avatar :size="42">
          <img :src="photo.avatar" :alt="`${photo.fullName} avatar.`" />
        </v-avatar>
      </nuxt-link>
      <div class="ml-4">
        <nuxt-link
          :to="`/photo/${photo.photoId}/${photo.photoSlug}?from=leaderboard`"
          class="no-underline"
        >
          <h3 class="text-subtitle-1 text-truncate font-weight-bold">
            {{ photo.photoTitle }}
          </h3>
        </nuxt-link>
        <nuxt-link
          :to="`/photographer/${photo.userUserName || photo.userId}`"
          class="no-underline"
        >
          <p>by {{ photo.fullName }}</p>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeaderboardPhotoDetails',
  props: {
    photo: {
      type: Object,
      required: true
    },
    me: {
      type: [Object, Boolean],
      default: () => {}
    }
  }
}
</script>

<style scoped>
.obscure-best-photo {
  align-items: center;
  background-color: #212121;
  color: white;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 300px;
}
.flex-avatar {
  flex: 0 0 !important;
}
</style>
